module.exports = __webpack_public_path__ + "static/img/division.d8634f74.png";